import { forwardRef } from 'react';

export const TextInput = forwardRef(function TextInput(
  { id, name, type = 'text', value, onChange, error = false, className = '', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      id={id}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      aria-invalid={error ? 'true' : undefined}
      className={`form-field-input ${className}`.trim()}
      {...rest}
    />
  );
});
